// extracted by mini-css-extract-plugin
module.exports = {"root":"_2gQ5_mG"};
    if(module.hot) {
      // 1545369455360
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  